import { Ajax } from '../helpers/ajax';

export class FormValidation {

	constructor(form) {
		this.form = form;
		this.validationUrl = form.validationUrl;
		this.errors = [];
		this.validated = false;
	}

	validateInput(inputElement) {
		return new Promise((resolve) => {
			const key = inputElement.getAttribute('name');
			const value = inputElement.value;
			const formData = `${key}=${value}`;
			Ajax.POST(`${this.validationUrl}`, 'json', formData).then((data) => {
				resolve(data);
			});
		});
	}

	validateInputGroup(inputName, inputType, inputGroup) {

		let formData = '';
		const suffix = inputType === 'checkbox' ? '[]' : '';
		for(let i = 0; i < inputGroup.length; i++) {
			const inputElement = inputGroup[i];
			const key = inputElement.name;
			const value = inputElement.value;
			formData += `${key}${suffix}=${value}&`;
		}
		if(!inputGroup.length) {
			formData = `${inputName}${suffix}=&`;
		}
		formData = formData.slice(0, -1);

		return new Promise((resolve) => {
			Ajax.POST(`${this.validationUrl}`, 'json', formData).then((data) => {
				resolve(data);
			});
		});
	}

	validateForm() {
		const formData = this.serializeForm();

		Ajax.POST(`${this.validationUrl}`, 'json', formData).then((data) => {
			this.errors = Object.keys(data);
			this.validated = !this.errors.length;
			if(this.validated) {
				this.form.elem.submit();
			} else {
				const inputs = this.form.singleValueInputs.concat(this.form.multiValueInputs).concat(this.form.fileUploadInputs);
				inputs.forEach(input => {
					if(this.errors.indexOf(input.elem.name) > -1) {
						input.setError(data[input.elem.name].localizedMessage);
					} else {
						input.removeError();
					}
				});
				this.form.elem.querySelector('.form-group__errormsg').scrollIntoView();
			}
		});

	}

	serializeForm() {

		let formData = '';
		const singleValueInputs = this.form.singleValueInputs.concat(this.form.fileUploadInputs);
		const multiValueInputs = this.form.multiValueInputs;

		for(let i = 0; i < singleValueInputs.length; i++) {
			if(singleValueInputs[i].elem.name) {
				formData += `${singleValueInputs[i].elem.name}=${singleValueInputs[i].elem.value}&`;
			}
		}

		if(multiValueInputs.length) {

			for(let i = 0; i < multiValueInputs.length; i++) {
				if(multiValueInputs[i].elem.checked) {
					const suffix = multiValueInputs[i].elem.type === 'checkbox' ? '[]' : '';
					formData += `${multiValueInputs[i].elem.name}${suffix}=${multiValueInputs[i].elem.value}&`;
				}
			}

			// if no multi value input is checked, we still have to send an empty value
			multiValueInputs.forEach(input => {
				const suffix = input.elem.type === 'checkbox' ? '[]' : '';
				if(formData.indexOf(`${input.elem.name}${suffix}=`) < 0) {
					formData += `${input.elem.name}${suffix}=&`;
				}
			});

		}

		return formData.slice(0, -1);
	}
}
